import { connect } from "react-redux";
import { formValueSelector, getFormValues } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/Statement/StatementForm";
import { getMe } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';
import { convert, addressToForm } from '../../converts';
import { VisibilityRaw } from '../../enum';
import { noop } from 'lodash';
import { diffObjects } from '../../CroUtils';

const postProcess = data => convert(data, {
  statementOfficial: { birthAddress: addressToForm, deliveryAddress: addressToForm },
  naturalPersonBusinesses: { address: addressToForm },
  legalBusinessAssociates: { legalPerson: { address: addressToForm } },
  organizationMember: { legalPerson: { address: addressToForm } },
  otherContracts: { address: addressToForm },
  corporationShares: { address: addressToForm },
  corporationSharesBefore: { address: addressToForm },
  incomes: { legalPerson: { address: addressToForm } },
  liabilities: { legalPerson: { address: addressToForm } },
  media: { legalPerson: { address: addressToForm } },
  realties: addressToForm,
  realtiesBefore: addressToForm,
});
const selector = formValueSelector('statementForm');
const allData = getFormValues('statementForm');

const mapStateToProps = (state, { params, auth = {}, location }) => {
  const { formData, versionDiff } = composeFormDataWithVersionDiff(
    location.state?.statement,
    location.state?.prevVersion || {}
  );

  return {
    breadcrumbsItems: [{ label: "Oznámení" }],
    formData: formData,
    versionDiff: versionDiff,
    versionValidTo: location.state?.versionValidTo,
    prevVersion: location.state?.prevVersion,
    readOnly: true,
    naturalPersonBusinessesEnabled: selector(
      state,
      "naturalPersonBusinessesEnabled",
    ), // || null,
    legalBusinessAssociatesEnabled: selector(
      state,
      "legalBusinessAssociatesEnabled",
    ), // || null,
    organizationMemberEnabled: selector(state, "organizationMemberEnabled"), // || null,
    mediaEnabled: selector(state, "mediaEnabled"), // || null,
    otherContractsEnabled: selector(state, "otherContractsEnabled"), // || null,
    realtiesEnabled: selector(state, "realtiesEnabled"), // || null,
    realtiesBeforeEnabled: selector(state, "realtiesBeforeEnabled"), // || null,
    commercialPapersEnabled: selector(state, "commercialPapersEnabled"), // || null,
    commercialPapersBeforeEnabled: selector(
      state,
      "commercialPapersBeforeEnabled",
    ), // || null,
    corporationSharesEnabled: selector(state, "corporationSharesEnabled"), // || null,
    corporationSharesBeforeEnabled: selector(
      state,
      "corporationSharesBeforeEnabled",
    ), // || null,
    chattelsEnabled: selector(state, "chattelsEnabled"), // || null,
    chattelsBeforeEnabled: selector(state, "chattelsBeforeEnabled"), // || null,
    incomesEnabled: selector(state, "incomesEnabled"), // || null,
    liabilitiesEnabled: selector(state, "liabilitiesEnabled"), // || null,

    realties: selector(state, "realties") || null,
    realtiesBefore: selector(state, "realtiesBefore") || null,
    commercialPapers: selector(state, "commercialPapers") || null,
    commercialPapersBefore: selector(state, "commercialPapersBefore") || null,
    corporationShares: selector(state, "corporationShares") || null,
    corporationSharesBefore: selector(state, "corporationSharesBefore") || null,
    chattels: selector(state, "chattels") || null,
    chattelsBefore: selector(state, "chattelsBefore") || null,
    incomes: selector(state, "incomes") || null,
    associates: selector(state, "legalBusinessAssociates") || null,
    business: selector(state, "naturalPersonBusinesses") || null,
    liabilities: selector(state, "liabilities") || null,
    media: selector(state, "media") || null,
    organizationMember: selector(state, "organizationMember") || null,
    otherContracts: selector(state, "otherContracts") || null,

    statementOfficial: selector(state, "statementOfficial") || null,

    toDate: selector(state, "toDate") || null,
    fromDate: selector(state, "fromDate") || null,

    promiseDocumented: selector(state, "official.promiseDocumented") || false,
    //workingPositions: selector(state, 'workingPositions') || [],
    workingPositions: selector(state, "officialWorkingPositions") || [],
    workingPositionsAll: selector(state, "official.workingPositions"),

    deputy: selector(state, "official.deputy") || false,
    deputyAndOthers: selector(state, "official.deputyAndOthers") || false,
    senator: selector(state, "official.senator") || false,
    senatorAndOthers: selector(state, "official.senatorAndOthers") || false,
    dos:
      selector(state, "official.deputy") ||
      selector(state, "official.senator") ||
      false,
    dosStatement: selector(state, "senator") || false,
    type_senator: selector(state, "type_senator"),
    hasPoint3: selector(state, "official.hasPoint3") || false,
    getMe,

    officialId: selector(state, "official.id"),
    getAllData: () => allData(state),

    hasFileRef: selector(state, 'hasFileRef'),

    lastModified: selector(state, 'lastModified'),
    creationDate: selector(state, 'creationDate'),

    isVillage: selector(state, 'isVillage'),
    isCity: selector(state, 'isCity'),
    isReleased: selector(state, 'isReleased'),

    type: selector(state, 'type'),
    state: selector(state, 'state'),
    checked: selector(state, 'checked'),
    visibility: selector(state, 'statementOfficial.visibility'),
    disabled: true,
    postProcess,
    isPublicStatement:
      selector(state, "visibility") === VisibilityRaw.PUBLIC || false,
  }
};

const mapDispatchToProps = (dispatch, { params, auth = {} }) => ({
  ...bindActionCreators(
    {
      breadcrumbs,
      getStatementPdf: () => noop,
      onSubmit: () => noop,
    },
    dispatch,
  ),
  onSubmit: (data) => noop,
  onSend: data => noop,
  onIncomplete: () => noop,
  onChecked: () => noop,
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);

// Reorder arrays in formData by itemOrder
const sortArraysByItemOrder = (obj) => {
  if (Array.isArray(obj)) {
    if (obj.length > 0 && obj[0] && typeof obj[0].itemOrder !== 'undefined') {
      const sorted = obj.filter(Boolean).sort((a, b) => (a.itemOrder || 0) - (b.itemOrder || 0));
      obj.length = 0;
      obj.push(...sorted);
    }

    obj.forEach(sortArraysByItemOrder);
  } else if (obj !== null && typeof obj === "object") {
    Object.values(obj).forEach(sortArraysByItemOrder);
  }
};

// Helper function for version differencies in Statement vs previous version
const composeFormDataWithVersionDiff = (formData, prevVersion) => {
    const diff = diffObjects(prevVersion, formData);
    const formDataCopy = JSON.parse(JSON.stringify(formData));

    diff.forEach(item => {
      if (item.type === "removed" && item.path) {
        const pathParts = item.path.split('.').map(part => {
          const match = part.match(/^([^\[]+)\[(\d+)\]$/);
          if (match) {
            return [match[1], Number(match[2])];
          }
          return part;
        }).flat();

        let obj = formDataCopy;
        for (let i = 0; i < pathParts.length - 1; i++) {
          const key = pathParts[i];
          if (typeof key === "number") {
            if (!Array.isArray(obj)) obj = obj[pathParts[i - 1]] = [];
            obj = obj[key] = obj[key] || {};
          } else {
            obj = obj[key] = obj[key] || {};
          }
        }
        const lastKey = pathParts[pathParts.length - 1];

        if (typeof lastKey === "number") {
          if (!Array.isArray(obj)) obj = [];
          obj[lastKey] = { ...item.oldValue };

          const enabledKey = pathParts.slice(0, -1).join('.') + 'Enabled';
          formDataCopy[enabledKey] = true;
        } else {
          obj[lastKey] = item.oldValue;
        }
      }
    });

    sortArraysByItemOrder(formDataCopy);

    const versionDiff = diff.reduce((acc, item) => {
      acc[item.path] = item.type;
      return acc;
    }, {});

    return { formData: formDataCopy, versionDiff };
}